module.exports = __webpack_public_path__ + "img/icon_1_36.57a2b308.png";